/**
 * Tables Routes
 */
import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Redirect, Route, RouteChildrenProps, Switch} from 'react-router-dom';
import {useTranslation} from "react-i18next";
import {config} from "../config";
// async components
import {
    AsyncUserCreateComponent,
    AsyncUserEditComponent,
    AsyncUserListComponent,
} from "../components/AsyncComponent/AsyncComponent";

const Users: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();

    return (
        <div className="content-wrapper">
            <Helmet>
                <title>{`${config.app.name} - ${translate('documentTypes.name')}`}</title>
                <meta name="description" content="Users"/>
            </Helmet>
            <Switch>
                <Route exact path={`${match?.url}`} component={AsyncUserListComponent}/>
                <Route exact path={`${match?.url}/create`} component={AsyncUserCreateComponent}/>
                <Route exact path={`${match?.url}/:id`} component={AsyncUserEditComponent}/>
                <Redirect exact from={`${match?.url}/`} to={`${match?.url}`}/>
            </Switch>
        </div>
    );
};

export default Users;
